import { useTranslation } from 'react-i18next';

import icon2 from '../../../assets/images/backoffice/kyc6.png';

import { SidebarSubtitle, SidebarTitle } from '../../../styles/stylesStyled';

import { Button } from '../../../styles/GlobalComponents';
import { useHistory } from 'react-router';

export const Success = () => {
  const history = useHistory();
  const { t } = useTranslation('settings');
  return (
    <div style={{ paddingTop: '12vh', textAlign: 'center' }}>
      <img src={icon2} alt='icon' style={{ marginBottom: 40, width: 220 }} />
      <SidebarTitle>{t('security.success')}</SidebarTitle>
      <SidebarSubtitle>
        {t('security.successfully_changed_password')}
      </SidebarSubtitle>
      <Button onClick={() => history.push('/login')} maxWidth='200px'>
        {t('security.login')}
      </Button>
    </div>
  );
};
